// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3PMRv","rootSmall":"AddTileButton_rootSmall__LZUOv"};